import { useEffect, useRef } from 'react';
import { FlattenInterpolation, ThemeProps } from 'styled-components';
import {
  useModelForm, FormInput, DateInlineInput, ThemeType,
  useIsAutoSave,
} from '../../../../..';

export function ModelDateInline({
  id = '',
  field,
  label = '',
  labelStyles = '',
  valueOverride,
  errorOverride = '',
  mutateValue = (newValue) => newValue,
  disabled = false,
  touchOverride = false,
  placeholder = '',
  required = false,
  small = false,
  onVisibleChange,
  containerCss,
}: {
  id?: string,
  field: string,
  label?: string,
  labelStyles?: string,
  valueOverride?: string,
  errorOverride?: string,
  mutateValue?: (newValue: Date | string) => any,
  disabled?: boolean,
  touchOverride?: boolean,
  placeholder?: string,
  required?: boolean,
  small?: boolean,
  onVisibleChange?: (visible: boolean) => void,
  containerCss?: FlattenInterpolation<ThemeProps<ThemeType>> | string,
}) {
  const {
    visible, errors, value, update, warnings,
  } = useModelForm(field, valueOverride, errorOverride);

  useEffect(() => {
    onVisibleChange?.(visible);
  }, [visible]);

  const { isAutoSave } = useIsAutoSave();
  const changed = useRef<boolean>(false);

  const onBlur = (targetValue: Date | string) => {
    if (changed.current && isAutoSave) {
      update({ [field]: mutateValue(targetValue) });
    }
    changed.current = false;
  };

  const onChange = (newValue: Date | string) => {
    changed.current = true;
    return update(
      { [field]: mutateValue(newValue) },
      isAutoSave,
    );
  };

  return (
    <FormInput visible={visible} css={containerCss}>
      <DateInlineInput
        id={`${id}-${field}`}
        label={label}
        labelStyles={labelStyles}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        touchOverride={touchOverride}
        placeholder={placeholder}
        required={required}
        small={small}
        isTooltipError
        errors={errors}
        warnings={warnings}
      />
    </FormInput>
  );
}
